<template>
    <BaseModal :id="id">
        <form @submit.prevent="submit">
            <Calendar
                v-model="range"
                selection-mode="range"
                :number-of-months="2"
                date-format="yy-mm-dd"
                :min-date="new Date()"
                :responsive-options="[{ breakpoint: '640px', numMonths: 1 }]"
                :autofocus="getRouteBaseName() !== 'index'"
                inline
            />
        </form>

        <template #footer>
            <div class="text-center">
                <Button
                    :disabled="!range.length"
                    :label="$t('programs_in_varosliget.datepicker_submit_button_label')"
                    :aria-label="$t('generic.search')"
                    @click.native="submit"
                />
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue';

export default {
    name: 'CalendarModal',
    components: {
        BaseModal,
    },
    data() {
        return {
            id: 'event-page-calendar',
            range: [],
        };
    },
    watch: {
        range(value) {
            this.$nuxt.$emit('update-event-page-filter-date-range', value);
        },
        '$route.path'() {
            this.range = [];
        },
    },
    created() {
        this.$nuxt.$on('set-default-event-page-filter-date-range', (value) => {
            this.range = value;
        });
    },
    methods: {
        submit() {
            this.$nuxt.$emit('submit-event-page-filter-date-range');
            this.$nuxt.$emit('close-modal', this.id);
        },
    },
};
</script>

<style scoped></style>

<style></style>
